import resume from '../assets/pdf/Ravi_Teja_Alchuri_Resume.pdf'

import display_pic from '../assets/RaviTejaDP.png'
export const headerData = {
    name: 'Ravi Teja Alchuri',
    firstName: 'Ravi Teja',
    lastName: 'Alchuri',
    title: "Director of Technology",
    role: "Director of Technology",
    // Short, credibility-forward positioning line used in the hero
    tagline: "Engineering leader architecting federally-regulated, AI-driven fleet platforms at national scale.",
    description: "I design and lead the distributed systems, compliance infrastructure, and applied-AI platforms behind a U.S. federally registered Electronic Logging Device platform, serving 100,000+ commercial vehicles, 2,000+ enterprise integrations, and 200+ resellers across the United States and Canada.",
    location: "Knoxville, Tennessee · USA",
    image: display_pic,
    resumePdf: resume
}
